import Vue from 'vue'
import router from './router'
import { antComponents } from './antd'
import App from './App.vue'
import { CommonComponents } from './use-common-components'
import { message } from 'ant-design-vue'
import './components/common/iconfont/iconfont.css'
import 'virtual:svg-icons-register'
import store, { storeKey } from './store'
import { createInstance } from '/@/root'
import '/@/styles/index.scss'
message.config({
  duration: 2, // 持续时间
  maxCount: 1 // 最大显示数, 超过限制时，最早的消息会被自动关闭
})
const app = createInstance(App)
app.use(store, storeKey)
app.use(router)
app.use(CommonComponents)
app.use(antComponents)
app.mount('#demo-app')
